import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import {Component, Input, ViewEncapsulation} from '@angular/core';
import {AceConfigInterface} from "ngx-ace-wrapper";

@Component({
  selector: 'micro-dialog-editor',
  templateUrl: './micro-dialog-editor.component.html',
})
export class MicroDialogEditorComponent {
  @Input() mode:string;
  @Input() theme:string;
  @Input() style: string;
  @Input() class: string;
  @Input() readOnly: boolean;
  @Input() disabled: boolean;
  @Input() required: boolean;
  @Input() text:any;
  @Input() config: AceConfigInterface;
  @Input() dialogStyle: string;

  constructor(public dialogRef: MatDialogRef<MicroDialogEditorComponent>) {
    dialogRef.disableClose = true;
    dialogRef.backdropClick().subscribe(e => {
      this.close();
    });
    dialogRef.keydownEvents().subscribe(e => {
      if (e.key === 'Escape' || e.code === 'Escape') {
        this.close();
      }
    });
  }

  close():void {
    this.dialogRef.close(this.text);
  }
}
